import { Badge, CardHeader, Flex, Text } from '@backstage/ui';
import { HistoryRangeSelector } from './history-range-selector';

type HistoryChartHeaderProps = {
  /**
   * When true, a details-page filter is active. History is always computed
   * across all entities, so a badge flags that filtered history is coming soon.
   */
  isFiltered: boolean;
  selectedDays: number;
  onSelectedDaysChange: (days: number) => void;
};

/**
 * Shared card header for the track and check history charts: the "Historical
 * Status" title, an optional "filters not applied" badge, and the range
 * selector. Kept in one place so both cards stay in sync.
 */
export const HistoryChartHeader = ({
  isFiltered,
  selectedDays,
  onSelectedDaysChange,
}: HistoryChartHeaderProps) => (
  <CardHeader>
    <Flex justify="between" align="center" gap="2">
      <Flex align="center" gap="2">
        <Text variant="body-large">Historical Status</Text>
        {isFiltered && (
          <Badge title="History reflects all entities; filtered history is coming soon.">
            Filtered results coming soon
          </Badge>
        )}
      </Flex>
      <HistoryRangeSelector
        selectedDays={selectedDays}
        onSelectedDaysChange={onSelectedDaysChange}
      />
    </Flex>
  </CardHeader>
);
